import { render } from "./Calendar.vue?vue&type=template&id=39174501&scoped=true"
import script from "./Calendar.vue?vue&type=script&lang=ts"
export * from "./Calendar.vue?vue&type=script&lang=ts"

import "./Calendar.vue?vue&type=style&index=0&id=39174501&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-39174501"

export default script